export const label = {
  'de-CH': 'Wiedergabe',
  'es-CR': 'Reproducir',
  'es-ES': 'Reproducir',
  'es-GT': 'Reproducir',
  'es-PA': 'Reproducir',
  'es-PE': 'Reproducir',
  'es-US': 'Reproducir',
  'es-UY': 'Reproducir',
  'fr-CA': 'Lecture',
  'fr-CH': 'Lecture',
  'fr-MA': 'Lecture',
  'fr-TN': 'Lecture',
  'nl-NL': 'Afspelen',
  ar: 'تشغيل',
  az: 'Oynat',
  be: 'Прайграць',
  bg: 'Възпроизвеждане',
  bs: 'Reprodukuj',
  cnr: 'Reprodukcija',
  cs: 'Přehrát',
  da: 'Afspil',
  de: 'Wiedergabe',
  el: 'Αναπαραγωγή',
  en: 'Play',
  es: 'Reproducir',
  et: 'Esita',
  fi: 'Toista',
  fr: 'Lecture',
  he: 'הפעל',
  hr: 'Reproduciraj',
  hu: 'Lejátszás',
  hy: 'Նվագարկել',
  id: 'Putar',
  is: 'Spila',
  it: 'Riproduci',
  ja: '再生',
  ka: 'დაკვრა',
  ko: '재생',
  lt: 'Atkurti',
  lv: 'Atskaņot',
  mk: 'Пушти',
  nl: 'Afspelen',
  no: 'Spill av',
  pl: 'Odtwórz',
  pt: 'Reproduzir',
  ro: 'Redare',
  ru: 'Воспроизвести',
  sk: 'Prehrať',
  sl: 'Predvajaj',
  sq: 'Luaj',
  sr: 'Pusti',
  sv: 'Spela upp',
  th: 'เล่น',
  tr: 'Oynat',
  uk: 'Відтворити',
  vi: 'Phát',
  zh: '播放',
};
